import { Dispatch } from 'redux';
import { fetchAlertSettings } from '../../../../services/discovery/fetchAlertSettings';
import { makeFetchModule } from '../../../_utils';
import { storeSourceSets } from '../../entities';

const callbacks = {
    onSuccess: (dispatch: Dispatch, { entities }: { entities: object }) => {
        dispatch(storeSourceSets(entities));
    },
};
const { reducer, fetchData, reset } = makeFetchModule(
    'app/discovery/alertSettingsFetching',
    fetchAlertSettings,
    callbacks
);

export default reducer;
export { fetchData, reset };
